const busyTextAttribute = "data-turbo-submits-with"
const legacyBusyTextAttribute = "data-disable-with"
const originalTextAttribute = "data-submit-state-original-text"
const originalValueAttribute = "data-submit-state-original-value"

function busyTextFor(element) {
  return element?.getAttribute(busyTextAttribute) || element?.getAttribute(legacyBusyTextAttribute)
}

// Only <input type=submit> shows its label via `value`; <button> shows innerHTML.
function labelledByValue(element) {
  return element instanceof HTMLInputElement
}

export function setBusyState(element) {
  const busyText = busyTextFor(element)
  if (!element || !busyText || element.dataset.submitStateBusy === "true") return

  element.dataset.submitStateBusy = "true"
  if (labelledByValue(element)) {
    element.setAttribute(originalValueAttribute, element.value)
    element.value = busyText
  } else {
    element.setAttribute(originalTextAttribute, element.innerHTML)
    element.innerHTML = busyText
  }

  element.setAttribute("aria-disabled", "true")
  if ("disabled" in element) {
    element.disabled = true
  } else {
    element.classList.add("disabled")
  }
}

export function resetBusyState(element) {
  if (!element || element.dataset.submitStateBusy !== "true") return

  if (element.hasAttribute(originalValueAttribute)) {
    element.value = element.getAttribute(originalValueAttribute)
    element.removeAttribute(originalValueAttribute)
  }

  if (element.hasAttribute(originalTextAttribute)) {
    element.innerHTML = element.getAttribute(originalTextAttribute)
    element.removeAttribute(originalTextAttribute)
  }

  element.removeAttribute("aria-disabled")
  element.classList.remove("disabled")
  if ("disabled" in element) element.disabled = false
  delete element.dataset.submitStateBusy
}

export function isBusy(element) {
  return element?.dataset.submitStateBusy === "true"
}

function formDisablesTurbo(form) {
  return form.dataset.turbo === "false"
}

function fallbackSubmitterFor(form) {
  return form.querySelector(`[${busyTextAttribute}], [${legacyBusyTextAttribute}]`)
}

document.addEventListener("submit", (event) => {
  if (!formDisablesTurbo(event.target)) return

  const submitter = event.submitter || fallbackSubmitterFor(event.target)
  const confirmMessage = submitter?.dataset.confirm || event.target.dataset.confirm
  if (confirmMessage && !window.confirm(confirmMessage)) {
    event.preventDefault()
    return
  }

  setBusyState(submitter)
})

document.addEventListener("turbo:submit-start", ({ detail }) => {
  setBusyState(detail.formSubmission.submitter)
})

document.addEventListener("turbo:submit-end", ({ detail }) => {
  resetBusyState(detail.formSubmission.submitter)
})

// Native (data-turbo="false") submissions never emit turbo:submit-end, so a
// BFCache/history restore would bring the button back disabled. Reset on pageshow.
window.addEventListener("pageshow", () => {
  document.querySelectorAll('[data-submit-state-busy="true"]').forEach(resetBusyState)
})
